var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfAsqQuestionBody", {
    staticClass: "ds-question-table",
    class: _vm.getCss,
    attrs: { "show-index": _vm.showIndex, question: _vm._self },
    scopedSlots: _vm._u([
      {
        key: "answer",
        fn: function () {
          return [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.form, "label-width": "0" } },
              [
                _c(
                  "el-table",
                  {
                    ref: "table",
                    attrs: {
                      data: _vm.rowsData,
                      border: "",
                      "header-cell-style": {
                        background: "#f5f7fa",
                        color: "#606266",
                      },
                    },
                  },
                  [
                    _vm._l(_vm.$items, function (item, $index) {
                      return _c("el-table-column", {
                        key: $index,
                        attrs: {
                          align: "center",
                          "min-width": "180",
                          label: item.text,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  item.type == "2"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            "class-name": "custon-column",
                                            prop:
                                              scope.$index + "," + item.uuid,
                                            rules: _vm.rules,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.readOnly || _vm.disabled,
                                                placeholder: "请选择",
                                              },
                                              model: {
                                                value:
                                                  scope.row[item.uuid].value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row[item.uuid],
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row[item.uuid].value",
                                              },
                                            },
                                            _vm._l(item.seting, function (it) {
                                              return _c("el-option", {
                                                key: it.value,
                                                attrs: {
                                                  label: it.text,
                                                  value: it.value,
                                                },
                                              })
                                            }),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { position: "relative" },
                                          attrs: {
                                            prop:
                                              scope.$index + "," + item.uuid,
                                            rules: _vm.rules,
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                _vm.readOnly || _vm.disabled,
                                            },
                                            model: {
                                              value: scope.row[item.uuid].value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row[item.uuid],
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row[item.uuid].value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    _vm.rowsData.length > _vm.defaultRows
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            fixed: "right",
                            label: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.$index >= _vm.defaultRows
                                      ? _c(
                                          "DsfButton",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.readOnly || _vm.disabled,
                                              "btn-style": "icon-text",
                                              title: "删除",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(scope)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4281505900
                          ),
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            !_vm.isDesign
              ? _c(
                  "DsfButton",
                  {
                    staticClass: "add-btn",
                    attrs: {
                      icon: "hao",
                      disabled: _vm.readOnly || _vm.disabled,
                      size: "small",
                    },
                    on: { click: _vm.getNewItem },
                  },
                  [_vm._v("新增填空")]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }